/* eslint-disable */
export default {
  space: '',
  setting: '設置',
  do: '，',
  dot: '。',
  chart: '統計',
  organization: '組織管理',
  allAccount: '所有賬戶',
  allDiseases: '所有病種',
  allOrganization: '所有組織',
  refresh: '刷新',
  username: '用戶名',
  remark: '備注',
  visiontech: '慧視AI',
  polymindf2fTitle: 'PolyMind AI 生成無創眼底熒光血管造影',
  EarlyPhase: '早期',
  MedPhase: '中期',
  LatePhase: '晚期',
  Angiography: '眼底血管造影視頻',
  userType: '用戶類型',
  createUser: '創建用戶',
  bindOrganization: '所屬組織',
  createdAt: '創建時間',
  edit: '編輯',
  normal: '普通用戶',
  userInfo: '用戶信息',
  organization_admin: '組織管理員',
  users: '用戶',
  reoprt: '報告',
  actions: '操作',
  assistantId: '助理編號',
  signout: '退出登錄',
  userPassword: '密碼',
  allReport: '所有報告',
  IDText: '請輸入ID查詢',
  NameText: '請輸入姓名查詢',
  uploadText: '上傳日期',
  export: '導出',
  reportType: '報告類型',
  view: '查看',
  copyButton: '備份資料',
  viewReport: '查看報告',
  type: '分類',
  osnegative: '左眼（陰性）',
  ospositive: '左眼（陽性）',
  osungradable: '左眼（無法分級）',
  odnegative: '右眼（陰性）',
  odpositive: '右眼（陽性）',
  odungradable: '右眼（無法分級）',
  totalData: '篩查總量',
  negativeData: '陰性結果報告',
  positiveData: '陽性結果報告',
  halfgradbleData: '部分有結果報告',
  ungradableData: '無法分級報告',
  usableData: '有效率',
  noData: '無結果',
  positivePersentData: '陽性率',
  gradeNums: '閱片工作量',
  chartTotal: '統計指標',
  toDay: '當天',
  thisWeek: '本周',
  thisMonth: '本月',
  thisQuarter: '本季度',
  thisYear: '本年度',
  HistoryTotal: '曆史總計',
  updatePassword: '修改密碼',
  newPassword: '新設密碼',
  confrimPassword: '確認密碼',
  ageText: '輸入的年齡不在評估模型的允許範圍（40歲至80歲），結果將會是N/A（即無結果）。',
  naodos: 'N/A表示左右眼底相得出的風險等級差異較大，無法顯示結果，屬少數案例。但由於其中一張眼底相評估的風險等級較高，建議咨詢醫生意見，跟進相關風險。',
  // admin
  datepicker: '指定範圍',
  address: '地址',
  name: '姓名',
  mobile: '手機號',
  birthday: '生日',
  startDate: '開始日期',
  to: '至',
  endDate: '結束日期',
  reportIsExist: '報告信息已存在，請不要重復提交',
  reportIsNone: '報告不存在，請檢查路徑',
  idcode: '身份證號碼',
  chooseGender: '請選擇性別',
  companyName: '慧視醫療',
  companyName2: 'Global STEM Professorship Scheme',
  adviceTitle: '轉診建議',
  patientId: 'ID',
  adviceText1: '存在陽性表現，建議就醫；',
  adviceText2: '拍攝失敗或分級失敗，建議諮詢眼科醫生或專業視光師。',
  adviceText2_1: '可分級結果未見陽性表現，但少部分結果存在無法分級情況，如有不適，請及時就診',
  adviceText3: '定期復診。',
  adviceText4: '此⼈⼯智能分級結果只能作為診斷的參考依據，不可取代專業的醫學意⾒、診斷或治療。',
  information: '基本信息',
  initing: '正在初始化...',
  findFundusSenor: '正在檢查相機與傳感器連接...',
  sensorText: '正在連接傳感器...',
  fundusText: '正在連接相機...',
  back: '返回',
  shutdonw: '關機',
  submit: '確 定',
  cancel: '取 消',
  password: '管理員密碼',
  title: '眼底拍照智能工作站',
  title1: '眼病篩查',
  title2: '心血管健康篩查',
  title3: '眼病篩查 + 心血管健康篩查',
  startText: '請點擊按鈕開始篩查',
  readme: '我已閱讀並同意',
  usage: '使用條款',
  age: '年齡',
  Diseases: '病種',
  gender: '性別',
  male: '男',
  female: '女',
  inputText: '請錄入信息',
  startBtnText: '開始篩查',
  eyeReportTitle: '人工智能眼睛健康篩查報告',
  cvdReportTitle: '心血管疾病風險評估報告',
  endText1: '請取走您的報告。',
  endText2: '掃描二維碼，可以將',
  endText3: '圖片和報告傳送到你的手機',
  ByeText1: '本次篩查已結束',
  ByeText2: '歡迎您下次光臨',
  GradingText1: '拍照結束。',
  GradingText2: '系統正在智能分級中，',
  GradingText3: '即將生成報告。請稍後。',
  createdText: '拍照時間',
  od: '右眼',
  os: '左眼',
  ungradable: '不可分級',
  Gradable: '可分級',
  grading: '分級中',
  dr: '糖尿病性視網膜病變',
  amd: '年齡相關性黃斑變性',
  cataract: '重度白內障',
  glaucoma: '青光眼視神經病變',
  drnp: '糖尿病性視網膜病變',
  gradeFail: '分析失敗',
  No_DR: '無明顯的視網膜病變',
  Mild_NPDR: '輕度NPDR  ',
  Moderate_NPDR: '中度NPDR  ',
  Severe_NPDR: '重度NPDR  ',
  Proliferative_DR: 'PDR ',
  medium_risk: '中風險',
  high_risk: '高風險',
  low_risk: '低風險',
  negative: '陰性',
  positive: '陽性',
  lowprobability: '可能性低',
  Possible: '有可能',
  cpositive: '可疑陽性',
  cvdResult: '評估結果',
  cvdPoint: '心血管疾病風險評分',
  early_or_intermediate: '早期或中期AMD',
  late_dry: '晚期幹性AMD',
  late_wet: '晚期濕性AMD',
  cvdInfoTitle: '眼底圖像及評估結果說明',
  cvdInfoText1: '雙眼的眼底圖像包括一張原始眼底照片，以及由人工智能系統自動生成的視網膜血管輪廓圖像、標準區域血管測量和全視網膜血管測量圖。',
  cvdInfoText2: 'N/A表示無結果。人工智能系統判別的年齡範圍是40歲至80歲之間，超出此年齡範圍，會顯示N/A。',
  cvdInfoText3: '低風險人群建議每兩年進行心腦血管檢查一次；中度風險人群建議每6-12個月進行心腦血管檢查一次；高風險人群建議每3個月進行心腦血管檢查一次。',
  cvdInfoText4_1: '（從 0% 到 100%）：您的分數是',
  cvdInfoText4_2: '，表示您 10 年內發生心血管事件的風險評分（百分比），其中低風險為 < 10%，中度風險為 10-20%，高風險為 ≥ 20%。該結果由人工智能系統完全基於眼底照片呈現的血管情況判斷生成。如果您的分數大於10%，則意味著您必須註意患心血管疾病的風險。',
  remarkTitle: '免責聲明',
  remarkText: '此報告由廣州慧視醫療科技有限公司的人工智能系統提供，心血管疾病風險評分是基於眼底照片、年齡、性別數據，使用目前先進的科研成果和人工智能技術分析評估得出。本報告不能替代專業的醫療建議或治療，僅供臨床專家參考。',
  remarkText2: '本報告由「Global STEM Professorship Scheme」支持下的人工智能系統所出具。請注意，本報告不能替代專業的醫療建議或治療，僅供臨床專家參考。',
  remarkText3: '此報告由OptiScreen的人工智能系統提供，心血管疾病風險評分是基於眼底照片、年齡、性別數據，使用目前先進的科研成果和人工智能技術分析評估得出。本報告不能替代專業的醫療建議或治療，僅供臨床專家參考。',
  cvdDoc_title: '心血管疾病風險資訊',
  eyeType: '拍攝模式',
  noPhoto: '拍攝失敗或未拍攝',
  other: '其他疾病',
  noOtherDisease: '未發現明顯病變。',
  otherText: '*本系統可輔助識別 59 種常見眼病 和 61 種罕見眼病，結果僅供參考，不能替代醫生的專業診斷與治療。',
  // 2024 10-14
  reportInfoTitle: '報告結果槪覽',
  noNormalDisease: '未發現明顯常見眼病',
  normalDiseases: '常見眼病指需轉診的糖尿病視網膜病變、青光眼視神經病變、重度白內障。',
  normalDiseases2: '常見眼病指需轉診的糖尿病視網膜病變、年齡相關性黃斑變性、青光眼視神經病變。',
  remarkText4: '心血管疾病風險評分是基於眼底照片、年齡、性別數據，使用目前先進的科研成果和人工智能技術分析評估得出。此報告由OptiScreen及PolyMind AI的人工智能系統提供。',
  remarkTextPolyMind: '心血管疾病風險評分是基於眼底照片、年齡、性別數據，使用目前先進的科研成果和人工智能技術分析評估得出。此報告由PolyMind AI的人工智能系統提供。',
  remarkTextVisiontech: '心血管疾病風險評分是基於眼底照片、年齡、性別數據，使用目前先進的科研成果和人工智能技術分析評估得出。此報告由慧視醫療的人工智能系統提供。',
  Recommendations: '綜合建議',
  imageQuality: '眼底圖片質量分析',
  diseaseD: '眼病風險評估',
  cvdD: '心血管疾病風險評估',
  shootingSuccess: '拍攝成功',
  shootingFail: '拍攝不成功',
  success: '成功',
  fail: '不成功',
  createdOrg: '创建组织',
  shootingFailText: '無法拍攝到視網膜，建議重新拍攝。',
  Evaluate_grading_results: '評估分級結果',
  poorQuality: '圖像質量不佳',
  interpretation_result: '分級結果解讀',
  poorQuality_in: '圖像質量不佳：表⽰您的眼底照片可能由於【瞳孔較小】，圖像質量未達到分級標準。',
  cvd_result_title: '心血管健康風險評估結果',
  cvd_dcm_result_title: '血管分割與評估結果',
  retinal_arteriovenous_ratio: '視網膜動靜脈比值',
  standard_value: '標準值',
  normal_standard: '視網膜動靜脈比值在正常範圍內。',
  unnormal_standard: '視網膜動靜脈比值小於標準值。',
  standard_text: '視網膜動靜脈比值指視網膜動脈和靜脈的比值，正常情況下視網膜動脈與靜脈的直徑比為2:3 (0.67)。如果出現異常情況，可能是由於血管痙攣、高血壓等原因導致，此時可能發生心血管疾病的風險會增加。',
  cvd_age: '視網膜年齡',
  your_cvd_age: '您的視網膜年齡是',
  smaller_age: '您的視網膜年齡小於實際年齡。表示您的生物學衰老程度相比同齡人更低。',
  older_age: '您的視網膜年齡大於實際年齡。表示您的生物學衰老程度相比同齡人更高。',
  remarkText5: '本報告不能替代專業的醫療建議或治療，僅供臨床專家參考。',
  odeye: '右眼',
  oseye: '左眼',
  glaucomaH2: '青光眼視神經病變',
  DRText: '疑似視網膜病變',
  HE: '出血',
  EX: '滲出',
  CWS: '棉絨斑',
  MA: '微血管瘤',
  fundus: '拍攝質量',
  // AnR
  public_Reject: '無法拍攝到視網膜，建議重新拍攝。',
  public_Usable: '',
  public_Good: '',
  other_negative_recommendations: '建議定期進行詳細眼睛健康檢查。',
  other_assessment: {
    "and neuroretinitis": "視神經網膜炎",
    "aneurysms": "視網膜動脈瘤",
    "vasculitis": "血管炎（眼部）",
    "behcet disease": "貝赫切特病",
    "best vitelliform macular dystrophy": "Best病（黃斑卵黃樣營養不良）",
    "bietti's crystalline dystrophy": "別氏晶體樣營養不良",
    "cmv retinitis": "巨細胞病毒性視網膜炎（CMV視網膜炎）",
    "coat's disease": "科茨病",
    "dalen–fuchs nodules": "Dalen–Fuchs 小結節",
    "eales' disease": "伊萊斯病",
    "hiv retinopathy": "HIV相關視網膜病變",
    "lyme disease": "萊姆病（眼部受累）",
    "stargardt disease": "斯塔加特病",
    "terson syndrome": "特森綜合征",
    "vogt-koyanagi-harada disease": "Vogt-小柳-原田病（VKH）",
    "von hippel-lindau syndrome": "馮·希佩爾-林道綜合征（VHL）",
    "x-linked juvenile retinoschisis ": "X連鎖少年性視網膜劈裂",
    "abnormal": "異常（非特指）",
    "active toxoplasmosis": "活動性弓形蟲性脈絡膜視網膜炎",
    "acute posterior multifocal placoid pigment epitheliopathy": "急性後多竈性斑片狀色素上皮病變（APMPPE）",
    "acute retinal necrosis": "急性視網膜壞死（ARN）",
    "adult-onset vitelliform macular dystrophy": "成人發病型卵黃樣黃斑營養不良",
    "age-related macular degeneration": "老年性黃斑變性（AMD）",
    "albinism": "白化病（眼部）",
    "aneurysm": "視網膜動脈瘤",
    "angioid streak": "血管樣條紋",
    "anterior ischemic optic neuropathy": "前缺血性視神經病變（AION）",
    "arterial-venous nicking": "動靜脈交叉壓迫（AV nicking）",
    "arteriosclerosis": "動脈硬化",
    "arteriovenous malformation": "動靜脈畸形（AVM）",
    "arteriovenous shunts": "動靜脈分流/短路",
    "asteroid bodies": "小體玻璃體病（Asteroid hyalosis）",
    "asteroid hyalosis": "小體玻璃體病（Asteroid hyalosis）",
    "atrophy": "萎縮（非特指）",
    "birdshot retinochoroidopathy": "鳥槍樣脈絡膜視網膜病變",
    "bone spicules pigmentation": "骨樣棘突色素沈著（色素性視網膜炎提示）",
    "branch retinal artery occlusion": "分支視網膜動脈阻塞",
    "branch retinal vein occlusion": "分支視網膜靜脈阻塞",
    "branching vascular network": "分支血管網絡（PCV特征）",
    "bull's eye maculopathy": "靶樣黃斑病變",
    "candida endophthalmitis": "念珠菌性眼內炎",
    "central areolar choroidal dystrophy": "中央凹脈絡膜營養不良",
    "central retinal artery occlusion": "中央視網膜動脈阻塞（CRAO）",
    "central retinal vein occlusion": "中央視網膜靜脈阻塞（CRVO）",
    "central serous chorioretinopathy": "中心性漿液性脈絡膜視網膜病變（CSCR）",
    "chloroquine toxicity": "氯喹/羥氯喹毒性（黃斑病變）",
    "chorioretinal atrophy": "脈絡膜視網膜萎縮",
    "chorioretinal dystrophy": "脈絡膜視網膜營養不良",
    "choroidal detachment": "脈絡膜脫離",
    "choroidal folds": "脈絡膜皺襞",
    "choroidal hemangioma": "脈絡膜血管瘤",
    "choroidal mass": "脈絡膜腫塊（未特指）",
    "choroidal melanoma": "脈絡膜黑色素瘤",
    "choroidal metastasis": "脈絡膜轉移瘤",
    "choroidal neoplasm": "脈絡膜腫瘤",
    "choroidal neovascularization": "脈絡膜新生血管（CNV）",
    "choroidal nevus": "脈絡膜痣",
    "choroidal osteoma": "脈絡膜骨瘤",
    "choroidal rupture": "脈絡膜破裂",
    "choroiditis": "脈絡膜炎",
    "chronic central retinal vein occlusion": "慢性中央視網膜靜脈阻塞",
    "chronic central serous chorioretinopathy": "慢性中心性漿液性脈絡膜視網膜病變",
    "chronic retinal vein occlusion": "慢性視網膜靜脈阻塞",
    "chronic toxoplasmosis": "慢性弓形蟲病（眼部）",
    "cilioretinal artery occlusion": "睫狀視網膜動脈阻塞",
    "combined hamartoma": "視網膜-視網膜色素上皮聯合錯構瘤",
    "commotio retinae": "視網膜震蕩",
    "cone dystrophy": "圓錐細胞營養不良",
    "cone-rod dystrophy": "圓錐-桿細胞營養不良",
    "congenital anomaly": "先天畸形（未特指）",
    "congenital chorioretinal coloboma": "先天性脈絡膜視網膜缺損（coloboma）",
    "congenital chorioretinopathy": "先天性脈絡膜視網膜病變",
    "congenital choroideremia": "脈絡膜缺如（Choroideremia）",
    "congenital coloboma": "先天性缺損（coloboma）",
    "congenital macular coloboma": "先天性黃斑缺損",
    "congenital optic disc coloboma": "先天性視盤缺損",
    "congenital stationary night blindness": "先天性停滯性夜盲（CSNB）",
    "congential optic disc abnormalities": "先天性視盤異常",
    "cotton-wool spot": "棉絮斑（軟性滲出）",
    "cystoid macular edema": "囊樣黃斑水腫（CME）",
    "detachment": "視網膜脫離（未特指）",
    "diabetic retinopathy": "糖尿病視網膜病變（DR）",
    "drusen": "玻璃膜疣（Drusen）",
    "dry age-related macular degeneration": "幹性老年性黃斑變性",
    "edema": "水腫（非特指）",
    "endophthalmitis": "眼內炎",
    "epiretinal membrane": "黃斑前膜（ERM）",
    "exudate": "滲出物",
    "exudative retinal detachment": "滲出性視網膜脫離",
    "familial exudative vitreoretinopathy": "家族性滲出性玻璃體視網膜病變（FEVR）",
    "fibroproliferation": "纖維增殖（增殖性改變）",
    "fibrovascular retinal pigment epithelial detachment": "視網膜色素上皮纖維血管性隆起",
    "fleck": "斑點樣病變",
    "gas-tamponade": "氣體填充術（gas tamponade）",
    "geographic atrophy": "地理樣萎縮（Geographic atrophy）",
    "glaucoma": "青光眼",
    "gyrate atrophy": "環狀脈絡膜視網膜萎縮",
    "hamartoma": "錯構瘤（非特指）",
    "hard drusen": "硬性玻璃膜疣",
    "hemorrhage": "出血（眼內/視網膜）",
    "high myopia": "高度近視",
    "hyperpigmentation": "色素沈著（增強）",
    "hyperplastic retinal pigment epithelium": "視網膜色素上皮增生",
    "hypertensive retinopathy": "高血壓性視網膜病變",
    "hypertrophy of the rpe": "視網膜色素上皮肥厚",
    "hypopigmentation": "色素減退",
    "idiopathic retinitis": "特發性視網膜炎",
    "infarction": "梗死（視網膜/視神經）",
    "intermediate uveitis": "中間型葡萄膜炎",
    "intraocular foreign body": "眼內異物",
    "intraretinal hemorrhage": "視網膜內出血",
    "intraretinal microvascular abnormalities": "視網膜內微血管異常（IRMA）",
    "ischemia": "缺血（視網膜）",
    "ischemic branch retinal vein occlusion": "缺血性分支視網膜靜脈阻塞",
    "ischemic central retinal vein occlusion": "缺血性中央視網膜靜脈阻塞",
    "ischemic optic neuropathy": "缺血性視神經病變",
    "lacquer crack": "漆裂（病理性近視相關）",
    "lamellar macular hole": "板層性黃斑裂孔",
    "large cup": "視杯增大（杯盤比增大）",
    "laser spots": "激光斑點（光凝術疤痕）",
    "late dry age-related macular degeneration": "晚期幹性老年性黃斑變性",
    "lattice degeneration": "晶格樣變性",
    "leukemic retinopathy": "白血病性視網膜病變",
    "lipemia retinalis": "視網膜脂血癥",
    "lymphoma": "眼部淋巴瘤",
    "macroaneurysm": "視網膜動脈瘤",
    "macula off retinal detachment": "黃斑脫離型視網膜脫離",
    "macular atrophy": "黃斑萎縮",
    "macular dystrophy": "黃斑營養不良",
    "macular ectopia": "黃斑異位/移位",
    "macular edema": "黃斑水腫",
    "macular hemorrhage": "黃斑出血",
    "macular hole": "黃斑裂孔",
    "macular telangiectasia": "黃斑毛細血管擴張癥（MacTel）",
    "maculopathy": "黃斑病變（未特指）",
    "mass": "腫塊（眼內）",
    "media opacity": "介質混濁（角膜/晶體/玻璃體）",
    "melanocytoma": "黑色素細胞瘤（視盤黑素細胞瘤）",
    "melanoma": "黑色素瘤（脈絡膜/葡萄膜）",
    "microaneurysm": "微動脈瘤",
    "mild nonproliferative diabetic retinopathy": "輕度非增殖性糖尿病視網膜病變",
    "moderate nonproliferative diabetic retinopathy": "中度非增殖性糖尿病視網膜病變",
    "morning glory syndrome": "晨光畸形（Morning glory syndrome）",
    "multifocal choroiditis": "多竈性脈絡膜炎",
    "multiple evanescent white dot syndrome": "多竈性瞬時白點綜合征（MEWDS）",
    "multiple myeloma": "多發性骨髓瘤（眼部改變）",
    "myelinated retinal nerve fiber layer": "視網膜髓鞘化神經纖維層",
    "myopia": "近視",
    "neoplasm": "腫瘤（未特指）",
    "neuroepithelial detachment": "神經上皮脫離",
    "neurofibromatosis": "神經纖維瘤病（眼部）",
    "neuroretinitis": "視神經網膜炎",
    "neuroretinopathy": "神經性視網膜病變",
    "nonperfusion area": "無灌註區",
    "nonproliferative diabetic retinopathy": "非增殖性糖尿病視網膜病變（NPDR）",
    "normal": "正常",
    "normal": "正常",
    "ocular candidiasis": "眼念珠菌病",
    "ocular histoplasmosis syndrome": "眼組織胞漿菌病綜合征（OHS）",
    "ocular ischemic syndrome": "眼缺血綜合征",
    "ocular parasitosis": "眼部寄生蟲感染",
    "ocular tuberculosis": "眼結核",
    "old retinal vein occlusion": "既往（陳舊）視網膜靜脈阻塞",
    "optic atrophy": "視神經萎縮",
    "optic disc drusen": "視盤小體 / 視盤鈣化",
    "optic disc edema": "視盤水腫",
    "optic disc melanocytoma": "視盤黑色素細胞瘤",
    "optic disc neovascularization": "視盤新生血管形成",
    "optic disc pallor": "視盤蒼白",
    "optic disc pit": "視盤裂孔",
    "optic nerve hypoplasia": "視神經發育不良",
    "optic neuritis": "視神經炎",
    "panuveitis": "全葡萄膜炎",
    "papillitis": "視神經乳頭炎（乳頭炎）",
    "pars plana vitrectomy": "鞏膜平面玻璃體切除術（Pars plana vitrectomy, PPV）",
    "patchy chorioretinal atrophy": "斑片狀脈絡膜視網膜萎縮",
    "pathologic myopia": "病理性近視",
    "pattern dystrophy": "模式性黃斑營養不良",
    "perifoveal telangiectasia": "黃斑周圍毛細血管擴張",
    "peripapillary atrophy": "視乳頭周圍萎縮",
    "pigmentary change": "色素改變",
    "plaquenil toxicity": "羥氯喹（Plaquenil）毒性（黃斑）",
    "polypoidal choroidal vasculopathy": "息肉樣脈絡膜血管病變（PCV）",
    "polypoidal vascular abnormality ": "息肉樣血管異常（PCV）",
    "poor quality": "圖像質量差",
    "posterior uveitis": "後葡萄膜炎",
    "posterior vitreous detachment": "玻璃體後脫離（PVD）",
    "preretinal hemorrhage": "視網膜前出血",
    "presumed ocular histoplasmosis syndrome": "假定眼組織胞漿菌病綜合征（POHS）",
    "proliferative diabetic retinopathy": "增殖性糖尿病視網膜病變（PDR）",
    "proliferative vitreoretinopathy": "增殖性玻璃體視網膜病變（PVR）",
    "pseudopapilledema": "假性乳頭水腫",
    "pseudoxanthoma elasticum": "假黃色瘤樣彈性纖維變性（PXE）",
    "punctate inner choroidopathy": "點狀脈絡膜病變（PIC）",
    "radiation retinopathy": "放射性視網膜病變",
    "red small dots": "小紅點（非特指）",
    "referable diabetic retinopathy": "需轉診的糖尿病視網膜病變",
    "retinal angiomatous proliferation": "視網膜血管母細胞增殖（RAP）",
    "retinal arterial macroaneurysm": "視網膜動脈瘤",
    "retinal artery occlusion": "視網膜動脈阻塞",
    "retinal capillary hemangioblastoma": "視網膜毛細血管血管母細胞瘤（RCH）",
    "retinal cavernous hemangioma": "視網膜海綿狀血管瘤",
    "retinal collateral": "視網膜側支血管",
    "retinal detachment": "視網膜脫離",
    "retinal dystrophy": "視網膜營養不良（未特指）",
    "retinal neovascularization": "視網膜新生血管",
    "retinal pigment epithelial detachment": "視網膜色素上皮剝離（PED）",
    "retinal pigment epithelial tears": "視網膜色素上皮撕裂",
    "retinal pigment epithelium hamartoma": "視網膜色素上皮錯構瘤",
    "retinal tear": "視網膜裂孔",
    "retinal telangiectasia": "視網膜毛細血管擴張",
    "retinal vein occlusion": "視網膜靜脈阻塞（RVO）",
    "retinal vessel attenuation": "視網膜血管變細",
    "retinitis": "視網膜炎",
    "retinitis pigmentosa": "色素性視網膜炎 / 視網膜色素變性（RP）",
    "retinoblastoma": "視網膜母細胞瘤",
    "retinopathy of prematurity": "早產兒視網膜病變（ROP）",
    "retinoschisis": "視網膜劈裂",
    "rhegmatogenous retinal detachment": "裂孔性視網膜脫離",
    "roth spots": "Roth斑",
    "sarcoidosis": "結節病（眼部）",
    "scar": "瘢痕",
    "scleral band": "鞏膜帶 / 環形帶",
    "serous pigment epithelial detachment": "漿液性色素上皮剝離（serous PED）",
    "serous retinal detachment": "漿液性視網膜脫離",
    "serpiginous choroiditis": "蛇行性脈絡膜炎",
    "severe nonproliferative diabetic retinopathy": "重度非增殖性糖尿病視網膜病變",
    "sickle cell retinopathy": "鐮狀細胞性視網膜病變",
    "silicone-oil-tamponade": "矽油填充（術後）",
    "solar retinopathy": "日光性視網膜病變",
    "staphyloma": "鞏膜葡萄腫（posterior staphyloma）",
    "subhyaloid hemorrhage": "玻璃體下（膜下）出血",
    "submacular hemorrhage": "黃斑下出血",
    "subretinal exudate": "視網膜下滲出",
    "subretinal fibrosis": "視網膜下纖維化",
    "subretinal hemorrhage": "視網膜下出血",
    "sympathetic ophthalmia": "交感性眼炎",
    "syphilis": "梅毒（眼部）",
    "systemic lupus erythematosus vasculitis": "系統性紅斑狼瘡相關血管炎",
    "tessellation": "棋盤樣眼底（tessellation）",
    "tortuous": "血管迂曲",
    "toxocariasis": "弓蛔蟲病（Toxocara眼部感染）",
    "toxoplasmosis": "弓形蟲病（眼部）",
    "traction": "牽拉（未特指）",
    "tractional retinal detachment": "牽拉性視網膜脫離",
    "tuberculosis": "結核（眼部）",
    "uveitis": "葡萄膜炎",
    "valsalva retinopathy": "瓦爾薩爾瓦（Valsalva）性視網膜病變",
    "vascular hamartoma": "血管錯構瘤",
    "vascular sheath": "血管鞘樣改變",
    "vasculitis": "血管炎（眼部）",
    "venous loop": "靜脈環",
    "viral retinitis": "病毒性視網膜炎（HSV/VZV/CMV等）",
    "vitelliform macular dystrophy": "卵黃樣黃斑營養不良",
    "vitreomacular traction syndrome": "玻璃體-黃斑牽拉綜合征",
    "vitreous degeneration": "玻璃體退行性變",
    "vitreous hemorrhage": "玻璃體出血",
    "vitreous opacity": "玻璃體混濁 / 浮動物",
    "vitritis": "玻璃體炎",
    "wet age-related macular degeneration": "濕性老年性黃斑變性",
    "white dot syndrome": "白點綜合征（壹組疾病）"
  },
  // drnp
  drnp_negative_assessment: '未發現明顯糖尿病性視網膜病變。',
  drnp_negative_recommendations: '建議定期進行詳細眼睛健康檢查。',
  drnp_positive_assessment: '高度懷疑存在糖尿病性視網膜病變, 請盡快諮詢專業人士作詳細檢查。',
  drnp_positive_recommendations: '眼底照片存在糖尿病性視網膜病變類似異常，可能由糖尿病引起，建議諮詢視光師或眼科醫生作進一步檢查和治療。如不及時就診治療，可能引起視力下降甚至導致失明。應注意控制血糖，均衡飲食，適度運動。',
  drnp_ungradable_assessment: '圖像質量不達分級標準，系統無法完成分析，可能原因包括但不限於瞳孔小，未能注視指示燈，拍攝時眨眼等。',
  drnp_ungradable_recommendations: '建議重新拍攝或到專業護眼中心進行詳細檢查。',
  // glaucoma
  glaucoma_negative_assessment: '未發現明顯青光眼視神經病變。',
  glaucoma_positive_assessment: '存在青光眼視神經病變的風險較高，如不及時就診治療，可能引起視野縮窄等視功能障礙。',
  glaucoma_negative_recommendations: '建議定期進行詳細眼睛健康檢查。',
  glaucoma_positive_recommendations: '存在高風險的青光眼視神經病變類似異常，很有可能是視神經受損的表現，建議諮詢視光師或眼科醫生的意見，接受進一步檢查和治療。如不及時就診治療，可能引起視野縮窄等視功能障礙。',
  glaucoma_low_risk_assessment: '未發現明顯青光眼視神經病變。',
  glaucoma_low_risk_recommendations: '建議定期進行詳細眼睛健康檢查。',
  glaucoma_medium_risk_assessment: '存在青光眼視神經病變的風險為中等。',
  glaucoma_medium_risk_recommendations: '存在中度風險的青光眼視神經病變類似異常，可能是視神經受損，亦可能是個人生長差異，建議諮詢視光師或眼科醫生的意見，接受進一步檢查。',
  glaucoma_high_risk_assessment: '存在青光眼視神經病變的風險較高，如不及時就診治療，可能引起視野縮窄等視功能障礙。',
  glaucoma_high_risk_recommendations: '存在高風險的青光眼視神經病變類似異常，很有可能是視神經受損的表現，建議諮詢視光師或眼科醫生的意見，接受進一步檢查和治療。如不及時就診治療，可能引起視野縮窄等視功能障礙。',
  glaucoma_ungradable_assessment: '圖像質量不達分級標準，系統無法完成分析，可能原因包括但不限於瞳孔小，未能注視指示燈，拍攝時眨眼等。',
  glaucoma_ungradable_recommendations: '建議重新拍攝或到專業護眼中心進行詳細檢查。',
  // cataract
  cataract_negative_assessment: '未發現明顯重度白內障風險。',
  cataract_negative_recommendations: '建議定期進行眼部健康檢查。',
  cataract_positive_assessment: '可能存在重度白內障或會引致視力下降。',
  cataract_positive_recommendations: '眼底照片發現可疑重度白內障類似異常，可能是由於晶狀體混濁或其它眼睛結構混濁引起，建議諮詢視光師或眼科醫生的意見，接受進一步檢查和治療。如不及時就診治療，可能引致視力下降。',
  cataract_ungradable_assessment: '圖像質量不達分級標準，系統無法完成分析，可能原因包括但不限於瞳孔小，未能注視指示燈，拍攝時眨眼等。',
  cataract_ungradable_recommendations: '建議重新拍攝或到專業護眼中心進行詳細檢查。',
  // amd
  amd_negative_assessment: '未發現明顯年齡相關性黃斑變性風險。',
  amd_negative_recommendations: '建議定期進行眼部健康檢查。',
  amd_positive_assessment: '可能存在齡相關性黃斑變性。',
  amd_positive_recommendations: '眼底照片發現可疑齡相關性黃斑變性異常。',
  amd_ungradable_assessment: '圖像質量不達分級標準，系統無法完成分析，可能原因包括但不限於瞳孔小，未能註視指示燈，拍攝時眨眼等。',
  amd_ungradable_recommendations: '建議重新拍攝或到專業護眼中心進行詳細檢查。',
  // cvd
  cvd_low_risk_recommendations: '低⾵險⼈群建議每年進⾏⼼腦⾎管及身體檢查⼀次;',
  cvd_medium_risk_recommendations: '中度⾵險⼈群建議諮詢醫生意見，跟進⼼腦⾎管健康風險;',
  cvd_high_risk_recommendations: '⾼⾵險⼈群建議盡快諮詢醫生意見，及早跟進⼼腦⾎管健康風險。',
  cvd_NA_40_80_recommendations: '⼈⼯智能系統適用的年齡範圍是40歲⾄80歲之間，超出此年齡範圍，會顯⽰N/A。',
  cvd_NA_recommendations: 'N/A表示左右眼底相得出的風險等級差異較大，因此無法顯示結果，屬少數案例。但由於其中一張眼底相評估的風險等級較高，建議咨詢醫生意見，跟進相關風險。',
  cvd_ungradable_assessment: '圖像質量不達分級標準，系統無法完成分析，可能原因包括但不限於瞳孔小，未能注視指示燈，拍攝時眨眼等。',
  cvd_ungradable_recommendations: '建議重新拍攝或到專業護眼中心進行詳細檢查。',
  // total recommend
  all_negative_recommendations: '建議定期進行眼睛健康檢查。',
  all_positive_recommendations: '建議諮詢視光師或眼科醫生的意見，定期重新複查眼底及心血管健康風險。',
  all_positive_recommendations_2: '注意均衡飲食、控制血糖和血壓，適量運動。維持良好的生活習慣，密切關注自身健康狀況。',
  half_ungradable_recommendations: '注意均衡飲食、控制血糖和血壓，適量運動。維持良好的生活習慣，密切關注自身健康狀況，建議定期重新複查眼底及心血管健康風險。',
  all_ungadable_recommendations: '圖像質量不達分級標準，系統無法完成分析，可能原因包括但不限於瞳孔小，未能注視指示燈，拍攝時眨眼等。建議重新拍攝或到專業護眼中心進行詳細檢查。',
  half_ungradable_text: '圖像質量不達分級標準，系統無法完成分析，可能原因包括但不限於瞳孔小，未能注視指示燈，拍攝時眨眼等。建議重新拍攝或到專業護眼中心進行詳細檢查。',
  cvddoc: {
    p1_title: '一、什麽是心血管疾病？',
    p1_1: '心血管疾病是關於心臟或者血管的疾病，又稱循環系統疾病，是一系列涉及循環系統的疾病。主要包括：缺血性心臟病、腦中風、心肌病、風濕性心臟病、高血壓心臟病、心內膜炎、心律不正、主動脈疾病、外周動脈疾病以及其它心血管和循環系統疾病。心血管疾病嚴重危害患者的身體健康，目前已成為人類的首位死亡原因。',
    p2_title: '二、誘發心血管疾病的病因',
    p2_1: '心血管疾病病因複雜，屬於多因素致病，包括生物和遺傳因素、環境因素、不良的生活方式等。',
    p2_3_s: '基本病因',
    p2_3: '：心血管疾病的直接病因或高危因素主要是吸煙、缺乏運動、肥胖、高血壓、血脂異常、糖尿病、感染和遺傳，其它還包括飲食不均衡和空氣污染等。多種因素並非獨立存在，而是呈現聚集態勢，互相影響，共同導致心血管疾病的發病。',
    p2_4_s: '遺傳因素',
    p2_4: '：遺傳因素是心血管疾病發病的獨立高危因素，有家族史的人士，其心血管疾病發病風險增加。',
    p2_5_s: '高血壓',
    p2_5: '：高血壓是心血管疾病發病的主要高危因素。研究顯示，在35至64歲人士當中，有36.1%的心血管疾病個案可歸因於高血壓。高血壓患者患冠心病的概率比沒有高血壓者增加3至4倍。',
    p2_6_s: '血脂異常',
    p2_6: '：血脂是血漿中的中性脂肪（膽固醇、甘油三酯）和類脂（磷脂、糖脂、固醇、類固醇等）的總稱，血脂異常通常指血清膽固醇、甘油三酯、低密度脂蛋白膽固醇水平升高，高密度脂蛋白膽固醇水平降低，這與臨床心血管疾病密切相關，尤其是低密度脂蛋白膽固醇升高。長期血脂異常可導致動脈壁形成粥樣斑塊，使管壁逐漸狹窄甚至閉塞。斑塊也可發生破裂，血小板聚集、血栓形成，阻塞血流，從而引發心肌梗死、腦中風，甚至猝死。',
    p2_7_s: '糖尿病',
    p2_7: '：糖尿病是冠心病、腦中風等心血管疾病的重要危險因素。',
    p2_8_s: '肥胖',
    p2_8: '：肥胖與心血管疾病的發病、发展相關，肥胖者動脈粥樣硬化危險增加，同時肥胖併發高血壓、糖尿病、血脂異常等其他疾病的風險增加。',
    p2_9_s: '其他因素：',
    p2_9: '高鹽攝入、高脂肪攝入、食品污染、過量飲酒、缺乏蔬菜水果等不均衡飲食，以及環境污染、空氣污染等都可增加患心血管病的風險。',
    p3_title: '三、心血管疾病的癥狀',
    p3_1_s: '早期癥狀',
    p3_1: '：心血管疾病多起病隱匿，患者在早期可以無特異性癥狀，有的表現為不明顯的胸悶、心悸、乏力、頭暈等。',
    p3_2_s: '典型癥狀',
    p3_2: '：心血管疾病種類比較多，主要常見的癥狀有胸悶、胸痛、心悸、水腫、頭痛、頭暈、體能下降、呼吸困難、暈厥，其他還包括發紺、咳嗽、眩暈(與頭暈有分別)、上腹脹痛、惡心、嘔吐等。(部分癥狀也見於其它系統疾病，因此應仔細鑒別)。',
    p4_title: '四、心血管疾病風險評估的作用',
    p4_1: '我們採用國際標準的心血管疾病風險等級進行劃分，風險等級為三類(高、中、低)：',
    p4_7: '評分依據：',
    p4_8: '①利用人工智能模型判斷眼底照片是否呈現心血管疾病特徵，計算風險值；',
    p4_9: '②視網膜年齡比實際年齡每大一歲，則風險評分增加4%；',
    p4_10: '③年齡因素：年齡越大，風險越高；',
    p4_11: '④性別因素：男性患病風險高於女性；',
    p4_12: '根據以上四個因素，AI模型進行綜合分析，給出心血管風險評估分數。',
    p5_title: '五、心血管疾病的預防',
    p5_1: '飲食均衡，宜低鹽、低脂，烹調時盡量使用植物油，主食應粗糧與細糧搭配，多食用高熱量且營養豐富的食物，如：瘦肉、雞、魚、乳類及豆製品，少食油膩食物，多食新鮮蔬菜和水果，少食油炸食品，禁煙戒酒。',
    p5_2: '應堅持適當的運動，如：戶外散步、慢跑、游泳等。每天運動30～60分鐘，按照個人身體狀況做不同的調整。',
    p6_title: '六、就診',
    p6_1: '當出現胸悶、胸痛、心悸、暈厥、頭痛、頭暈、呼吸困難等異常情況時，應及時就醫，尤其有高血壓、血脂異常、高血糖等疾病史，吸煙、肥胖以及心血管疾病家族史的患者。',
    p7_title: '提示：本報告不能替代專業的醫療建議或治療，僅供臨床專家參考。'
  },
  eyedoc_title_1: '建議解讀',
  eyedoc1: {
    p1_1_s: '不可分級',
    p1_1: '：表⽰您的眼底照片未達到分級標準，請根據轉診建議及時就診。',
    p1_2_s: '陰性',
    p1_2: '：表⽰您的眼底照片顯⽰未⾒相關病變，定期複查即可。',
    p1_3_s: '可疑陽性及陽性',
    p1_3: '：表⽰您的眼底照片顯⽰疑似存在或存在病變的情況，請根據轉診建議及時就診。',
    p1_4_s: '低風險',
    p1_4: '：表示您的眼底照片顯示存在病變的風險較低，請定期複查。',
    p1_5_s: '中風險或高風險',
    p1_5: '：表示您的眼底照片顯示存在病變的風險為中度或高度，請根據轉診建議及時就診。'
  },
  eyedoc_amd: {
    p1_1_s: '不可分級',
    p1_1: '：表⽰您的眼底照片未達到分級標準，請根據轉診建議及時就診。',
    p1_2_s: '可能性低',
    p1_2: '：表⽰您的眼底照片顯⽰未⾒相關病變，定期複查即可。',
    p1_3_s: '有可能',
    p1_3: '：表⽰您的眼底照片顯⽰疑似存在或存在病變的情況，請根據轉診建議及時就診。',
    p1_4_s: '低風險',
    p1_4: '：表示您的眼底照片顯示存在病變的風險較低，請定期複查。',
    p1_5_s: '中風險或高風險',
    p1_5: '：表示您的眼底照片顯示存在病變的風險為中度或高度，請根據轉診建議及時就診。'
  },
  eyedoc_dr: {
    p1_1_s: '不可分級',
    p1_1: '：表⽰您的眼底照片未達到分級標準，請根據轉診建議及時就診。',
    p1_2_s: '陰性',
    p1_2: '：表示您的眼底照⽚顯示未出現糖尿病性視網膜病變，建議定期復查。',
    p1_3_s: '可疑陽性及陽性',
    p1_3: '：表示您的眼底照⽚顯示存在糖尿病性視網膜病變，請您根據轉診建議及時就診。'
  },
  eyedoc_title_2: '糖尿眼資訊',
  eyedoc2: {
    p1_1: '糖尿病視網膜病變（簡稱「糖尿眼」）是糖尿病併發症的⼀種，發病機率與糖尿病類型、發病時間、治療⽅式等因素關系密切。',
    p1_2: '糖尿眼常⾒癥狀：視物模糊，視⼒下降、失明等。',
    p1_3: '關於糖尿眼，您需要知道的：',
    p2_title: '⼀、糖尿病類型的影響',
    p2_1: '糖尿病視網膜病變可能是因為糖尿病患者的⾎糖長期處於較⾼的狀態，從⽽使眼部微⾎管出現缺氧、缺⾎性改變，引起眼底新⽣⾎管形成，同時出現局部出⾎等情況，可能會導致影像變形、視⼒下降等，情況較為嚴重時可能會有視⼒喪失，1型糖尿病患者糖尿病性視網膜病變的發病率在90%左右，⽽2型糖尿病患者糖尿病性視網膜病變的發病率為50%-80%。',
    p3_title: '⼆、糖尿眼發病時間',
    p3_1: '若患糖尿病的時間在10年以上，則糖尿病性視網膜病變的可能性在69%-90%，20年以上的患者接近100%都存在糖尿病性視網膜病變。',
    p4_title: '三、糖尿病治療⽅式對糖尿眼的影響',
    p4_1: '主要視乎是否使⽤胰島素，使⽤胰島素控製⾎糖的糖尿病患者，糖尿病視網膜病變發⽣機率約為80%，⽽未使⽤胰島素的糖尿病患者，糖尿病視網膜病變的發⽣機率約為50%。',
    p5_title: '四、糖尿眼的預防',
    p5_1: '糖尿病患者在⽇常⽣活管理基礎上，應更加愛護眼睛、保護眼睛。建議吃富含膳食纖維，或者讓⾎糖上升較慢的碳⽔化合物食物如蔬菜、⾖類、⽔果、全麥⾯包和⾕類食品等；提倡餐單應包括深海⿂、雞蛋、⼤⾖等優質蛋⽩；適當補充維⽣素D、維⽣素C有助於潰瘍的愈合。少吃多餐，規律飲食。',
    p5_2: '可通過視⼒檢查或定期眼底拍照檢查進⾏監測，若患者出現突發的視⼒下降應及時就診。',
    p6_title: '五、糖尿病視網膜病變的檢查與治療：',
    p6_1_s: '· 檢查',
    p6_1: '：透過眼底鏡檢查、眼底彩⾊照相等檢查可檢測視網膜是否出現糖尿病性視網膜病變。若眼底有出血點，建議做眼底螢光血管造影檢查，可更清楚了解糖尿眼的程度。',
    p6_2_s: '· 確診',
    p6_2: '：糖尿眼以是否存在視網膜異常新生血管作為判斷標準，可分為非增殖性糖尿病性視網膜病變，和增殖性糖尿病性視網膜病變。',
    p6_3_s: '· 治療',
    p6_3: '：近年來，醫藥科技進步很快，尤其是抗⾎管⽣成藥物的出現，使糖尿眼的治療有了更多的選擇，包括激光治療、抗⾎管⽣成藥物眼內註射治療等；有些晚期糖尿眼可能需要激光、藥物和⼿術聯合治療。',
    p7_title: '提示：如您的分級結果是陽性，請參考就診建議，去醫院眼科或眼科專科醫院尋求醫⽣的幫助。本報告僅供參考，不能替代專業建議或治療'
  },
  eyedoc_title_3: '青光眼資訊',
  eyedoc3: {
    p1_title: '一、什麼是青光眼？',
    p1_1: '青光眼是一種逐漸進展的眼部疾病，通常與眼壓升高有關。它會對視神經造成損傷，可能導致視野損失和失明。大部分的青光眼通常在早期沒有明顯症狀，患者難以察覺。',
    p2_title: '二、青光眼的分類',
    p2_1: '青光眼可以分為開角型和閉角型。開角型青光眼房角正常但排水不通，閉角型青光眼則是由於虹膜與角膜之間的角房角狹窄造成眼壓急劇升高。',
    p3_title: '三、青光眼的分類及癥狀',
    p3_1: '青光眼可以分為慢性和急性，而青光眼個案中有超過8成屬慢性。慢性青光眼比急性青光眼更危險，往往去到中後期才會有較明顯的癥狀，可能對視力已造成無法復原的損害。',
    p3_2: '急性：因眼壓急劇升高而導致出現眼紅、眼部疼痛、視力模糊、看燈光有彩虹圈、頭痛、噁心及嘔吐等明顯癥狀。',
    p3_3: '慢性：早期並沒有明顯癥狀，但隨著病情漸漸惡化，視力會下降及視野縮窄，大部分在患者發覺時可能已到中後期。',
    p4_title: '四、青光眼的檢查與治療',
    p4_1: '檢查青光眼通常包括眼壓測量、眼底檢查、視野測試和視神經檢查。治療方法包括使用藥物降低眼壓、手術增加眼部排水、激光治療等。早期診斷和治療是預防青光眼進展的關鍵。',
    p4_2: '青光眼是一個嚴重的眼部疾病，早期青光眼只能透過定期眼部檢查和及早發現及治療，可以控制病情並保護視力。如有疑慮，請尋求專業醫生或眼科視光師的指導和建議。'
  },
  eyedoc_title_4: '年齡相關性白內障資訊',
  eyedoc4: {
    p1_title: '一、什麼是年齡相關性白內障？',
    p1_1: '年齡相關性白內障是一種常見的眼部疾病，通常與年齡的增長有關。它是由於眼中的晶狀體變得混濁，影響到正常視力。這種白內障可以逐漸發展，並且在年長時更加普遍。',
    p2_title: '二、年齡相關性白內障的症狀',
    p2_1: '年齡相關性白內障的常見症狀包括視力模糊、感覺像有霧氣或薄霧在眼前、對比度降低、顏色感知減退等。這些症狀可能會逐漸加重，影響日常生活和活動。',
    p3_title: '三、年齡相關性白內障的檢查與治療',
    p3_1: '檢查年齡相關性白內障通常包括眼部檢查、視力測試和眼底檢查。治療方法主要是通過手術來取出混濁的晶狀體，並植入人工晶體來恢復視力。這種手術被稱為白內障摘除手術，是一種安全且常見的手術。',
    p3_2: '年齡相關性白內障是普遍的眼部問題，但通過正確的檢查和及時的手術治療，可以恢復視力並提高生活質量。建議年長者定期進行眼部檢查，並尋求專業醫生的建議和指導。'
  },
  eyedoc_title_5: '年齡相關性黃斑變性資訊',
  eyedoc5: {
    p1_1: '年齡相關性黃斑變性（Age-Related Macular Degeneration，簡稱AMD或ARMD）是一種與年齡增長相關的眼病，主要影響眼睛的黃斑區。黃斑區位於視網膜中心，是負責中央視覺和細節識別（如閱讀、面部識別和駕駛）的重要部位。AMD是導致50歲以上人群視力喪失的主要原因之一。',
    p2_title: '一、AMD的類型',
    p2_1: 'AMD主要有兩種類型：',
    p2_2: '● 乾性AMD：這是最常見的形式，占所有AMD病例的85%-90%。乾性AMD的特點是黃斑區的光感受器細胞逐漸退化和死亡，形成小的黃色沉積物（稱為玻璃體疣）。這種類型的AMD進展緩慢，通常影響雙眼，但可能導致中心視力逐漸喪失。',
    p2_3: '● 濕性AMD：這種類型的AMD較為嚴重，占所有AMD病例的10%-15%。濕性AMD是由於異常血管在黃斑區生長，導致血液和液體滲漏，進而引起視網膜損傷和瘢痕形成。濕性AMD的進展速度快，可能導致嚴重的中心視力喪失。',
    p3_title: '二、AMD的症狀',
    p3_1: 'AMD的症狀取決於其類型：',
    p3_2: '● 乾性AMD：早期可能無症狀或僅有輕微的視覺模糊。隨著病情進展，可能會出現視覺中心的盲點或直線變形。',
    p3_3: '● 濕性AMD：症狀通常突然出現，包括視力急劇下降、視覺中心模糊或失真，以及單眼失明。',
    p4_title: '三、AMD的風險因素',
    p4_1: 'AMD的風險因素包括：',
    p4_2: '● 年齡增長',
    p4_3: '● 家族史',
    p4_4: '● 吸煙',
    p4_5: '● 心臟病',
    p4_6: '● 超重',
    p4_7: '● 高血壓',
    p4_8: '● 高脂血症',
    p4_9: '● 某些遺傳因素',
    p4_10: '● 長期暴露于陽光下',
    p4_11: '● 營養不良（如缺乏Ω-3脂肪酸）',
    p5_title: '四、AMD的診斷',
    p5_1: 'AMD的診斷通常通過眼科檢查進行，醫生可能會要求患者注視一個網格（稱為Amsler網格），以檢查視力和視網膜的異常。此外，醫生可能會使用特殊的成像技術（如眼底照相）來觀察眼睛的內部結構。',
    p6_title: '五、AMD的治療',
    p6_1: 'AMD的治療取決於其類型和嚴重程度：',
    p6_2: '● 乾性AMD：目前沒有特效治療方法，但補充劑（如葉黃素和玉米黃質）可能有助於減緩病情進展。',
    p6_3: '● 濕性AMD：治療通常包括眼內注射抗血管內皮生長因子（anti-VEGF）藥物，如艾力雅®（阿柏西普），以及激光光凝和玻璃體手術等。',
    p7_title: '六、AMD的預防',
    p7_1: '預防AMD的措施包括：',
    p7_2: '● 戒煙',
    p7_3: '● 健康飲食，增加Ω-3脂肪酸的攝入',
    p7_4: '● 控制血壓和體重',
    p7_5: '● 保護眼睛免受紫外線傷害',
    p7_6: '隨著人口老齡化的加劇，AMD的患者數量預計將持續上升。因此，提高公眾對AMD的認識，以及推廣早期診斷和治療，對於保護老年人的視力至關重要。        ',
    p7_7: '提示：本報告僅供參考，不能替代專業建議或治療，請根據自身情況，考慮尋求眼科專科醫生幫助。'
  }
}
